import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontFamily, getFontSize } from '@process-advisor/process-miner/shared/theme';

const StyledTitle = styled.div`
    font-size: ${getFontSize('small')};
    color: ${getColor('darkFontColor')};
    text-align: left;
    font-family: ${getFontFamily('lato')};
    margin-bottom: 15px;
    display: inline-block;
`;

type Props = {
    className?: string
}

export const Title: React.FC<Props> = ({ children, className }) => (
    <StyledTitle className={className}>
        {children}
    </StyledTitle>
);
